import {
  convertToCamelCase,
  convertToSnakeCase,
} from "../redux/actions/helpers";
import { dataFormatter } from "./admin";
import axios from "axios";
import Cookies from "js-cookie";

export const loadOrganizations = async (page, searchTerm, verified, sort) => {
  const response = await axios
    .get(
      `/api/v1/organizations?page=${page}&verified=${verified}&sort=${sort}&search_term=${searchTerm}`,
      {
        headers: {
          Authorization: `Bearer ${
            Cookies.get("jwt") || localStorage.getItem("jwt")
          }`,
        },
      }
    )
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    const meta = JSON.parse(response.request.response)["meta"];
    const results = dataFormatter.deserialize(response.data).map((obj) => {
      return convertToCamelCase(obj);
    });

    return { results: results, meta: meta };
  }
};

export const loadOrganization = async (id, withDashboard = false) => {
  const response = await axios
    .get(`/api/v1/organizations/${id}?withDashboard=${withDashboard}`, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const createOrganization = async (formData) => {
  const response = await axios
    .post(
      "/api/v1/organizations",
      {
        data: { attributes: convertToSnakeCase(formData) },
      },
      {
        headers: {
          Authorization: `Bearer ${
            Cookies.get("jwt") || localStorage.getItem("jwt")
          }`,
        },
      }
    )
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const updateOrganization = async (formData, id) => {
  const response = await axios
    .put(
      `/api/v1/organizations/${id}`,
      {
        data: { attributes: convertToSnakeCase(formData) },
      },
      {
        headers: {
          Authorization: `Bearer ${
            Cookies.get("jwt") || localStorage.getItem("jwt")
          }`,
        },
      }
    )
    .catch((error) => {
      throw error;
    });
  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const deleteOrganization = async (id) => {
  const response = await axios
    .delete(`/api/v1/organizations/${id}`, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const validateVat = async (vat) => {
  const response = await axios
    .post(
      "/api/v1/organizations/validate_vat",
      {
        data: { attributes: convertToSnakeCase(vat) },
      },
      {
        headers: {
          Authorization: `Bearer ${
            Cookies.get("jwt") || localStorage.getItem("jwt")
          }`,
        },
      }
    )
    .catch((error) => {
      throw error;
    });
  if (response.status === 200) {
    return convertToCamelCase(response.data);
  }
};

export const getCountries = async () => {
  const response = await axios
    .get("/api/v1/countries", {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((errors) => {
      throw errors;
    });

  if (response.status === 200) {
    return response.data;
  }
};
